import { BaseReceiptStatusDto } from '@api';

const baseOfferStatusDto: BaseReceiptStatusDto = {
  id: 0,
  status: '',
  created: '2021-01-01Z00:00:000Z',
  lastChange: '2021-01-01Z00:00:000Z',
};

export const OFFER_STATUS: BaseReceiptStatusDto[] = [
  {
    ...baseOfferStatusDto,
    id: 1,
    status: 'Status A',
  },
  {
    ...baseOfferStatusDto,
    id: 2,
    status: 'Status B',
  },
  {
    ...baseOfferStatusDto,
    id: 3,
    status: 'Status C',
  },
  {
    ...baseOfferStatusDto,
    id: 4,
    status: 'Status D',
  },
];
